module.exports = __webpack_public_path__ + "img/icon-seal-type.77644efa.png";